export const IsDosageValid = (minDose: number, maxDose: number): boolean =>
  !(minDose > maxDose) && minDose >= 0 && maxDose >= 0 && maxDose < 10001;

export const IsNameValid = (name: string | undefined): boolean =>
  name !== undefined && name !== "" && name.length < 20;

export const IsUnitsValid = (units: string | undefined): boolean =>
  units !== undefined && units !== "" && units.length < 6;
